import ArtifactGroupType from "../base/ArtifactGroupType";


const PriamDiadem = {
  id: '143',
  name: "Priam's Diadem",
  groupIcon: 'LegendsOfTroy',
  type: ArtifactGroupType.LEGENDS_OF_TROY,
  icon: 'PriamsDiadem',
  power: 10
};

export default PriamDiadem;
